import React from 'react';

import { createStyles, withStyles, Theme, Typography, Box, Tabs, Tab } from '@material-ui/core';

import commonStyles from '../common/common.module.css';

import CustomerWaitTimeContainer from './customerWaitTime/CustomerWaitTimeContainer';
import TopCustomersContainer from './topCustomers/TopCustomersContainer';
import SecurityScreeningContainer from './securityScreening/SecurityScreeningContainer';
import { Moment } from 'moment';
import AirlineType from '../../models/AirlineType';
import TeamEfficiencyContainer from './teamEfficiency/TeamEfficiencyContainer';

const materialStyles = (theme: Theme) =>
  createStyles({
    rootTab: {
      backgroundColor: 'var(--primaryblue) !important',
      color: 'white !important',
      maxWidth: '100%'
    },
    selectedTab: {
      backgroundColor: 'var(--secondarygreen) !important',
      color: 'white !important'
    },
    tabWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '-10px',
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    },
    scrollBtn: {
      color: 'black',
      backgroundColor: 'lightgrey',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
      '&$disabled': {
        opacity: '0.4',
        backgroundColor: 'var(--primaryblue) !important',
        color: 'white !important'
      }
    },
    comingSoon: {
      width: 'fit-content',
      margin: 'auto',
      paddingTop: '25vh',
      color: 'var(--primaryblue)'
    },
    '@media (min-width: 860px)': {
      tabWrapper: {
        width: 'calc(100% + 38px)',
        marginLeft: '-20px'
      }
    },
    '@media (max-width: 815px)': {
      tabWrapper: {
        marginTop: '40px',
      }
    }
  });

interface AnalyticsProps {
  classes: any;
  tab: string;
  airlines: AirlineType[];
  startDate: Moment;
  endDate: Moment;
  handleTab: Function;
  handleChangeDate: (dateType: string, event: any) => void;
};
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography component='div'>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const analytics = (props: AnalyticsProps) => {
  const { classes } = props;

  return (
    <div className={`${commonStyles.w100}`} >
      <Tabs
        value={props.tab}
        onChange={(e, v) => props.handleTab(v)}
        className={`${commonStyles.tabContainer} ${classes.tabWrapper}`}
        variant="scrollable"
        scrollButtons="on"
        indicatorColor="primary"
        textColor="primary"
        aria-label="scrollable force tabs"
        classes={{
          scrollButtons: classes.scrollBtn
        }}
      >
        <Tab
          classes={{
            root: classes.rootTab,
            selected: classes.selectedTab
          }}
          className={`${commonStyles.tab} ${commonStyles.scrollTabs} ${classes.activeTab}`}
          value='customer-wait-time'
          label='Customer Wait Time' />
        <Tab
          classes={{
            root: classes.rootTab,
            selected: classes.selectedTab
          }}
          className={`${commonStyles.tab} ${commonStyles.scrollTabs} ${classes.activeTab}`}
          value='top-customers'
          label='Top Customers' />
        <Tab
          classes={{
            root: classes.rootTab,
            selected: classes.selectedTab
          }}
          className={`${commonStyles.tab} ${commonStyles.scrollTabs} ${classes.activeTab}`}
          value='team-efficiency'
          label='Team Efficiency' />
        <Tab
          classes={{
            root: classes.rootTab,
            selected: classes.selectedTab
          }}
          className={`${commonStyles.tab} ${commonStyles.scrollTabs} ${classes.activeTab}`}
          value='security-screening'
          label='Security Screening' />
        <Tab
          classes={{
            root: classes.rootTab,
            selected: classes.selectedTab
          }}
          className={`${commonStyles.tab} ${commonStyles.scrollTabs} ${classes.activeTab}`}
          value='import-payments'
          label='Import Payments' />
        <Tab
          classes={{
            root: classes.rootTab,
            selected: classes.selectedTab
          }}
          className={`${commonStyles.tab} ${commonStyles.scrollTabs} ${classes.activeTab}`}
          value='cwgt-discrepancies'
          label='CWGT Discrepancies' />
      </Tabs>
      <TabPanel value={props.tab} index='customer-wait-time'>
        <CustomerWaitTimeContainer startDate={props.startDate} endDate={props.endDate} airlines={props.airlines} handleChangeDate={props.handleChangeDate} />
      </TabPanel>
      <TabPanel value={props.tab} index='top-customers'>
        <TopCustomersContainer startDate={props.startDate} endDate={props.endDate} airlines={props.airlines} handleChangeDate={props.handleChangeDate} />
      </TabPanel>
      <TabPanel value={props.tab} index='team-efficiency'>
        <TeamEfficiencyContainer startDate={props.startDate} endDate={props.endDate} airlines={props.airlines} handleChangeDate={props.handleChangeDate} />
      </TabPanel>
      <TabPanel value={props.tab} index='security-screening'>
        <SecurityScreeningContainer startDate={props.startDate} endDate={props.endDate} airlines={props.airlines} handleChangeDate={props.handleChangeDate} />
      </TabPanel>
      <TabPanel value={props.tab} index='import-payments'>
        <div>
          <h1 className={classes.comingSoon}>Coming Soon...</h1>
        </div>
      </TabPanel>
      <TabPanel value={props.tab} index='cwgt-discrepancies'>
        <div>
          <h1 className={classes.comingSoon}>Coming Soon...</h1>
        </div>
      </TabPanel>
    </div>
  );
};

export default withStyles(materialStyles)(analytics);